import Main from '../components/main';
import Faq from '../../../domains/faq';
import MentorListPage from '../../../domains/mentor/ui/pages/MentorListPage';

export const Home = (props: Record<string, unknown>) => {
  return (
    <>
      <Main {...props} />
      <MentorListPage />
      <Faq {...props} />
    </>
  );
};

export default Home;
